import React, { useEffect, useState } from "react";
import Select from "react-select";
import { Range } from "react-range";
import ProductCards from "./ProductCards";
import { useNavigate } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { GetParameters } from "../../api/parameterService";
import { getProductCategory } from "../../api/productCategory";
import "../../assets/css/binstock.css";
import { AddToCart } from "../../api/cartService";
import { toast } from "react-toastify";

export default function BinStockSection() {
    document.title = "Bin Stock";

    const [filteredData, setFilteredData] = useState({});
    const [activeFilter, setActiveFilter] = useState(null);
    const [selectedFilters, setSelectedFilters] = useState({ price: [5000, 100000] });
    const [categories, setCategories] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const navigate = useNavigate();

    const filters = [
        "Metal",
        "Gold Quality",
        "Price",
        "Diamond Shape",
        "Diamond Quality",
        "By Ring Style",
    ];

    const products = [
        { productId: 1, name: "Starshine Ring", metal: "Rose Gold", image: "/assets/images/binstock/Ring1.png" },
        { productId: 2, name: "Aurora Ring", metal: "Rose Gold", image: "/assets/images/binstock/Ring2.png" },
        { productId: 3, name: "Effulgent Ring", metal: "Rose Gold", image: "/assets/images/binstock/Ring3.png" },
        { productId: 4, name: "Nimbus Ring", metal: "Rose Gold", image: "/assets/images/binstock/Ring4.png" },
        { productId: 5, name: "Moonlit Ring", metal: "Rose Gold", image: "/assets/images/binstock/Ring5.png" },
        { productId: 6, name: "Celest Ring", metal: "Rose Gold", image: "/assets/images/binstock/Ring6.png" },
        { productId: 7, name: "Skyward Ring", metal: "Rose Gold", image: "/assets/images/binstock/Ring7.png" },
        { productId: 8, name: "Sacred Stud Earring", metal: "Rose Gold", image: "/assets/images/binstock/Ring8.png" },
        { productId: 9, name: "Pinnacle Stud Earring", metal: "Rose Gold", image: "/assets/images/binstock/Ring9.png" },
        { productId: 10, name: "Clarity Stud Earring", metal: "Rose Gold", image: "/assets/images/binstock/Ring10.png" },
        { productId: 11, name: "Gaze Stud Earring", metal: "Rose Gold", image: "/assets/images/binstock/Ring11.png" },
        { productId: 12, name: "Crown Stud Earring", metal: "Rose Gold", image: "/assets/images/binstock/Ring12.png" },
        { productId: 13, name: "Divine Stud Earring", metal: "Rose Gold", image: "/assets/images/binstock/Ring13.png" },
        { productId: 14, name: "Linara Stud Earring", metal: "Rose Gold", image: "/assets/images/binstock/Ring14.png" },
        { productId: 15, name: "Oren Stud Earring", metal: "Rose Gold", image: "/assets/images/binstock/Ring15.png" },
        { productId: 16, name: "Zest Stud Earring", metal: "Rose Gold", image: "/assets/images/binstock/Ring16.png" },
        { productId: 17, name: "Bold Ring", metal: "Rose Gold", image: "/assets/images/binstock/Ring17.png" },
        { productId: 18, name: "Velvet Ring", metal: "Rose Gold", image: "/assets/images/binstock/Ring18.png" },
        { productId: 19, name: "Glimmer Ring", metal: "Rose Gold", image: "/assets/images/binstock/Ring19.png" },
        { productId: 20, name: "Jewel Ring", metal: "Rose Gold", image: "/assets/images/binstock/Ring20.png" },
    ];

    const filterMapping = {
        Metal: "METAL_COLOR",
        "Gold Quality": "GOLDKT",
        "Diamond Shape": "SHAPE",
        Price: "PRICE",
        "Diamond Quality": "QUALITY",
        "By Ring Style": "RING_STYLE",
    };

    // Fetch parameters for filters
    async function fetchParameters() {
        try {
            const response = await GetParameters();
            if (response?.Message?.[0]?.RETURNCODE === "1") {
                //console.log("parameter response", response)
                const data = response?.Parameters || [];
                const mapped = Object.keys(filterMapping).reduce((acc, key) => {
                    acc[key] = data
                        .filter((p) => p.PARATYPE === filterMapping[key])
                        .map((p) => ({
                            value: p.PARA_ID,
                            label: p.PARANAME,
                        }));
                    return acc;
                }, {});

                setFilteredData(mapped);
            }
            else {
                toast.error(response?.Message?.[0]?.RETURNMESSAGE || "No stock found");
            }
        } catch (err) {
            console.error("Error fetching parameters:", err);
            setError("Failed to load parameters");
        } finally {
            setLoading(false);
        }
    }

    // Fetch product categories
    async function fetchProductCategory() {
        try {
            const response = await getProductCategory();
            //console.log("getProductCategory response :: ");
            console.log(response);
            if (response && Array.isArray(response.JewelleryCategoryDetail)) {
                const activeCategories = response.JewelleryCategoryDetail
                    .filter((cat) => cat.ISACTIVE)
                    .map((cat) => ({
                        productId: cat.PRODUCTCATEGORY_ID,
                        name: cat.PRODUCTCATEGORYNAME,
                        image: cat.PRODUCTCATEGORYIMAGE,
                    }));

                setCategories(activeCategories);
            }
        } catch (err) {
            console.error("Error fetching product categories:", err);
            setError("Failed to load product categories");
        } finally {
            setLoading(false);
        }
    }

    // Fetch both APIs on mount
    useEffect(() => {
        fetchParameters();
        fetchProductCategory();
    }, []);

    // Handle select dropdown change
    const handleSelectChange = (filterKey, selected) => {
        setSelectedFilters((prev) => ({
            ...prev,
            [filterKey]: selected,
        }));
    };

    // Add to Cart function
    const handleAddToCart = async (product) => {
        if (!product) return;

        try {
            //console.log("Adding to cart:", product);

            const payload = {
                Style_ID: String(product.productId),
                Quantity: "1",
                Remark: `Added from bin stock: ${product.name}`,
            };

            //console.log("AddToCart Payload:", payload);

            const response = await AddToCart(payload);
            //console.log("AddToCart API Response:", response);

            toast.success("Product added to cart successfully!", {
                theme: "colored",
                position: "top-right",
                autoClose: 3000
            });

        } catch (error) {
            console.error("AddToCart Error:", error);

            // Show the actual error message from the API
            const errorMessage = error.message || "Failed to add product to cart";
            toast.error(errorMessage, {
                theme: "colored",
                position: "top-right",
                autoClose: 5000
            });
        }
    };

    return (
        <section className="binstock-section">
            <ToastContainer position="top-right" autoClose={3000} theme="colored" />

            <div className="binstock-container container">
                {/* Categories */}
                <div className="binstock-categories">
                    {categories.length > 0 ? (
                        categories.map((cat) => (
                            <button key={cat.productId} className="category-tab" type="button">
                                {cat.name}
                            </button>
                        ))
                    ) : (
                        <p className="no-categories">No categories available</p>
                    )}
                </div>

                {/* Filters */}
                <div className="binstock-filters">
                    {filters.map((filterName) => (
                        <div key={filterName} className="filter-item">
                            <span className="filter-label">{filterName}</span>
                            <button
                                className={`filter-button ${activeFilter === filterName ? "active" : ""}`}
                                onClick={() =>
                                    setActiveFilter(activeFilter === filterName ? null : filterName)
                                }
                            >
                                <span className="arrow-icon">
                                    <i className="bx bxs-chevron-down"></i>
                                </span>
                            </button>

                            {activeFilter === filterName && (
                                <div className="filter-select-dropdown">
                                    {filterName === "Price" ? (
                                        <div className="price-range">
                                            <label className="price-label">
                                                ₹{selectedFilters.price?.[0]} – ₹{selectedFilters.price?.[1]}
                                            </label>
                                            <Range
                                                step={5000}
                                                min={5000}
                                                max={100000}
                                                values={selectedFilters.price}
                                                onChange={(values) =>
                                                    setSelectedFilters((prev) => ({
                                                        ...prev,
                                                        price: values,
                                                    }))
                                                }
                                                renderTrack={({ props, children }) => {
                                                    const [minVal, maxVal] = selectedFilters.price;
                                                    const range = 100000 - 5000;
                                                    const left = ((minVal - 5000) / range) * 100;
                                                    const width = ((maxVal - minVal) / range) * 100;

                                                    return (
                                                        <div
                                                            onMouseDown={props.onMouseDown}
                                                            onTouchStart={props.onTouchStart}
                                                            ref={props.ref}
                                                            className="price-track"
                                                            style={{
                                                                background: `linear-gradient(to right,
                                                                    #ddd ${left}%,
                                                                    #004a91 ${left}%,
                                                                    #004a91 ${left + width}%,
                                                                    #ddd ${left + width}%)`,
                                                            }}
                                                        >
                                                            {children}
                                                        </div>
                                                    );
                                                }}
                                                renderThumb={({ props }) => (
                                                    <div {...props} className="price-thumb" />
                                                )}
                                            />
                                        </div>
                                    ) : (
                                        <Select
                                            isMulti
                                            isClearable
                                            isSearchable
                                            placeholder={`Select ${filterName}`}
                                            options={filteredData[filterName] || []}
                                            value={selectedFilters[filterName] || []}
                                            onChange={(selected) => handleSelectChange(filterName, selected)}
                                            classNamePrefix="binstock-select"
                                            menuIsOpen
                                            autoFocus
                                        />
                                    )}
                                </div>
                            )}
                        </div>
                    ))}
                </div>

                {/* Product Cards */}
                <div className="binstock-products">
                    {products.map((item) => (
                        <ProductCards
                            key={item.productId}
                            image={item.image}
                            name={item.name}
                            metal={item.metal}
                            price={item.price}
                            productId={item.productId}
                            handleAddToCart={() => handleAddToCart(item)}
                            onOpenDetail={() => navigate(`/bin-stock-detail/${item.productId}`)}
                        />
                    ))}
                </div>
            </div>
        </section>
    );
}